<template>
    <div class="towers">
        <div class="towers-banner-section">
            <div class="towers-title-container">
                <h1 class="towers-title">TOWERS</h1>
                <p class="towers-subtitle">Watch it rise. Exit in time.</p>
            </div>
            <img src="@/assets/img/christmas/towerBanners.jpg" alt="Towers Banner" class="towers-banner" />
        </div>
        <div class="towers-container">
            <TowersControls />
            <div class="container-game-wrapper">
                <div class="game-header">
                    <div class="game-difficulty">{{ towersRisk.toUpperCase() }}</div>
                </div>
                <div class="container-game" v-bind:class="['game-' + towersRisk]">
                    <div class="game-grid">
                        <TowersRow v-for="row in 8" v-bind:key="row" v-bind:row="row - 1" />
                    </div>
                </div>
            </div>
        </div>

        <Bets />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Bets from '@/components/bets/Bets';
    import TowersRow from '@/components/towers/TowersRow';
    import TowersControls from '@/components/towers/TowersControls';
    import Payment from '@/components/Payment';

    export default {
        name: 'Towers',
        metaInfo: {
            title: 'Towers'
        },
        components: {
            Bets,
            TowersRow,
            TowersControls,
            Payment
        },
        methods: {
            ...mapActions([
                'socketConnectTowers', 
                'socketDisconnectTowers'
            ])
        },
        computed: {
            ...mapGetters([
                'towersRisk'
            ]),
        },
        created() {
            this.socketConnectTowers();
        },
        beforeRouteLeave(to, from, next) {
            this.socketDisconnectTowers();
            next();
        }
    }
</script>

<style scoped>
    .towers {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
      /*  padding: 45px 10px;*/
        min-height: 100vh;
    }

    .towers-banner-section {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 100px;
    }

    .towers-title-container {
        position: absolute;
        left: 100px;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: baseline;
        gap: 20px;
        flex-wrap: nowrap;
        margin: 90px 0 0 45px;
    }

    .towers-title {
        font-family: 'Anton SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 64px;
        line-height: 69px;
        letter-spacing: 0%;
        color: var(--gradient-txt-yellow);
        background: var(--gradient-txt-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .towers-subtitle {
        font-family: 'Anton', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #ffffff;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .towers-banner {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        position: relative;
        z-index: 1;
    }

    .towers .towers-container {
        display: flex;
        max-width: 1000px;
        /*margin: 0 150px 0 150px; */
        width: 100%;  
        position: relative;
        z-index: 1;
        gap: 20px;
    }

    /* Same layout as homepage: wrapper only adds vertical spacing; Payment uses its own margin/padding */
    .towers-payment-content {
        width: 100%;
        margin: 40px 0 0 0;
        position: relative;
        z-index: 1;
    }


    .towers .towers-controls {
        width: 30%;
        min-width: 320px;
        max-width: 421px;
        display: flex;
        flex-direction: column;
        justify-content: start;
        gap: 10px;
        padding: 20px 15px;
        background: var(--bg-table-background);
        border-radius: 15px;
       /* border: 1px solid var(--accent-yellow);*/
        margin-top: 0;
        box-sizing: border-box;
        overflow: visible;
        margin-left: 100px;
    }

    .towers .towers-controls .controls-mode {
        padding-top: 0;
        border-top: none;
    }

    .towers .towers-controls .controls-amount {
        margin-top: 15px;
    }

    .towers .towers-controls button.button-bet,
    .towers .towers-controls button.button-cashout {
        width: 100%;
    }

    .towers .container-game-wrapper {
        flex: 1;
        position: relative;
        margin-right: 100px;
        background: url('../assets/img/towers/towersSunBk.jpg') no-repeat center center;
        background-size: cover;
        border-radius: 20px;
        overflow: visible;
        padding: 20px;
        display: flex;
        flex-direction: column;
    }


    .towers .container-game-wrapper .game-header {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 0;
        padding-bottom: 20px;
        z-index: 2;
    }

    .towers .container-game-wrapper .game-difficulty {
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        text-transform: uppercase;
        margin-bottom: 10px;
        z-index: 3;
        position: relative;
    }

    .towers .container-game {
        width: 90%;
        max-width: 600px;
        height: auto;
        min-height: fit-content;
        display: flex;
        flex-direction: column;
        padding: 0;
        border-radius: 20px;
        /*background: var(--bg-table-background);*/
       /* border: 1px solid rgba(255, 255, 255, 0.1);*/
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5);
        position: relative;
        z-index: 3;
        box-sizing: border-box;
        margin: 0 auto;
    }

    .towers .container-game .game-grid {
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
        padding: 20px;
        padding-top: 20px;
    }


    @media only screen and (max-width: 1150px) {
        .towers-banner-section {
            margin-bottom: 15px;
            padding: 0 var(--spacing-md);
        }

        .towers-title-container {
            left: var(--spacing-md);
            gap: 15px;
            margin: 30px 0 0 5px;
        }

        .towers-title {
            font-size: 48px;
            line-height: 52px;
        }

        .towers-subtitle {
            font-size: 18px;
        }

        .towers {
            padding: 25px 10px 45px 10px;
        }

        .towers .towers-container {
            width: 100%;
            margin: 0;
            padding: 0 10px;
        }

        .towers .towers-controls {
            width: 30%;
            min-width: 250px;
        }

        .towers-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 850px) {
        .towers-banner-section {
            padding: 0 var(--spacing-sm);
        }

        .towers-title-container {
            left: var(--spacing-sm);
            gap: 12px;
            margin: 30px 0 0 5px;
        }

        .towers-title {
            font-size: 36px;
            line-height: 40px;
        }

        .towers-subtitle {
            font-size: 16px;
        }

        .towers-payment-content {
            width: 100%;
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 545px) {
        .towers-banner-section {
            padding: 0 var(--spacing-xs);
        }

        .towers-title-container {
            left: var(--spacing-xs);
            gap: 10px;
            margin: 30px 0 0 5px;
        }

        .towers-title {
            font-size: 28px;
            line-height: 32px;
        }

        .towers-subtitle {
            font-size: 14px;
        }

        .towers-payment-content {
            margin: 40px 0 0 0;
        }
    }

    /* Mobile: hide entire banner section */
    @media only screen and (max-width: 1024px) {
        .towers-banner-section {
            display: none !important;
        }
    }

    @media only screen and (max-width: 950px) {
        .towers-banner-section {
            margin-bottom: 10px;
        }

        .towers {
            padding: 25px 10px 500px 10px;
        }
    }

    @media only screen and (max-width: 850px) {
        .towers .towers-container {
            flex-direction: column-reverse;
            gap: 15px;
        }

        .towers .towers-controls {
            margin-left: 0;
            width: 100%;
            max-width: 100%;
            min-width: 0;
        }

        .towers .towers-controls button.button-bet,
        .towers .towers-controls button.button-cashout {
            width: 100%;
        }

        .towers .container-game-wrapper {
            width: 100%;
            margin-right: 0;
            padding: 12px;
        }

        .towers .container-game-wrapper .game-header {
            padding-bottom: 12px;
        }

        .towers .container-game-wrapper .game-difficulty {
            margin-bottom: 6px;
            font-size: 14px;
        }

        .towers .container-game {
            width: 95%;
            max-width: 100%;
        }

        .towers .container-game .game-grid {
            padding: 12px;
            padding-top: 12px;
        }
    }

    @media only screen and (max-width: 545px) {
        .towers-banner-section {
            margin-bottom: 8px;
        }

        .towers .towers-container {
            padding: 0 5px;
            gap: 10px;
        }

        .towers .towers-controls {
            padding: 15px 10px;
            margin-left: 0;
        }

        .towers .container-game-wrapper {
            margin-right: 0;
            padding: 10px;
            margin-top: 60px;
        }

        .towers .container-game-wrapper .game-header {
            padding-bottom: 10px;
        }

        .towers .container-game-wrapper .game-difficulty {
            margin-bottom: 4px;
            font-size: 13px;
        }

        .towers .container-game {
            width: 100%;
            max-width: 100%;
        }

        .towers .container-game .game-grid {
            padding: 10px;
            padding-top: 10px;
        }
    }

    @media only screen and (max-width: 425px) {
    }

    @media only screen and (max-width: 350px) {
    }
</style>